<template>
	<v-container fluid>
		<v-layout align-center justify-center>
			<v-flex xs12 sm8 md4>
				<form>
					<v-card class="elevation-12">
						<v-toolbar color="primary" dark flat>
							<v-toolbar-title>
								<v-img position="start start" :src="require('@/assets/img/logo_titulo_invert.svg')" class="my-3" contain height="40"></v-img>
							</v-toolbar-title>
						</v-toolbar>
						<v-card-text>
							<v-container>
									<v-text-field
										label="Nome de utilizador"
										name="username"
										v-model="UserInfo.username"
										prepend-icon="person"
										type="text">
									</v-text-field>
									<v-text-field
										id="password"
										label="Palavra-passe"
										name="password"
										v-model="UserInfo.password"
										prepend-icon="lock"
										type="password">
									</v-text-field>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary" :disabled="!UserInfo.username || !UserInfo.password" @click="login">Entrar</v-btn>
						</v-card-actions>
					</v-card>
				</form>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
    export default {
        data: () => ({
			UserInfo: {
				username: null,
				password: null
			}
        }),

        methods: {
			login () {
				this.$http.post(process.env.VUE_APP_AUTH_ROOT + '/login/', this.UserInfo).then(function(loginData){
					console.log(loginData);

					this.$http.get(process.env.VUE_APP_API_ROOT + `/utilizador?username=${this.UserInfo.username}`).then(function(utilizadorData){
						console.log(utilizadorData);

						this.$store.commit('setCurrentUser', {
							id: utilizadorData.body[0].id,
							username: this.UserInfo.username,
							role: utilizadorData.body[0].groups[0].name,
							authtoken: loginData.body.key
						});

						this.$router.push({ name: 'home'})
					}, response => { // error callback
						console.log('ERRO na obtenção dos dados do utilizador', response);
						
						// TODO
						alert('Não foi possível autenticar com sucesso.');
					});
				}, response => { // error callback
					console.log('ERRO no login', response);
					
					// TODO
					alert('Não foi possível autenticar com sucesso.');
				});
			}
        }
    }
</script>